import { ChangeDetectionStrategy, Component, inject } from '@angular/core';
import { MatIcon } from '@angular/material/icon';
import {
  DYNAMIC_COMPONENT_DATA,
  NgCommonModule,
} from '@principle-theorem/ng-shared';
import {
  IAccTransactionExtendedData,
  TransactionStatus,
} from '@principle-theorem/principle-core/interfaces';
import { DAY_MONTH_YEAR_DATE_FORMAT } from '@principle-theorem/shared';
import { ITransactionExtendedDataDisplayData } from '../../../transactions-display/transaction-display/transaction-display-line/transaction-display-line.component';

@Component({
  selector: 'pr-acc-extended-data',
  imports: [NgCommonModule, MatIcon],
  templateUrl: './acc-extended-data.component.html',
  styleUrl: './acc-extended-data.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class AccExtendedDataComponent {
  data = inject<
    ITransactionExtendedDataDisplayData<IAccTransactionExtendedData>
  >(DYNAMIC_COMPONENT_DATA);

  awaitingConfirmation =
    this.data.transaction.status === TransactionStatus.Pending;

  readonly dateFormat = DAY_MONTH_YEAR_DATE_FORMAT;
}
